import { createContext, useContext, type ReactNode } from "react";
import useDraftBookingNotifications, {
  type DraftBookingNotifications,
} from "../hooks/booking/useDraftBookingNotifications";
import AddOnToast from "../components/common/AddOnToast";
import PhoneVerifyToast from "../components/common/PhoneVerifyToast";
import PendingCartToast from "../components/common/PendingCartToast";

const MyCartContext = createContext<DraftBookingNotifications | null>(null);

export function MyCartProvider({ children }: { children: ReactNode }) {
  const cart = useDraftBookingNotifications();
  return (
    <MyCartContext.Provider value={cart}>
      {children}
      <AddOnToast />
      <PhoneVerifyToast />
      <PendingCartToast />
    </MyCartContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useMyCart(): DraftBookingNotifications {
  const ctx = useContext(MyCartContext);
  if (!ctx) throw new Error("useMyCart must be used inside MyCartProvider");
  return ctx;
}
